import _ from 'lodash';
import PageContainer from './PageContainer';
import Draft from '../models/Draft';
import User from '../models/User';
import Template from '../models/Template';
import session from '../models/Session';

import history from '../libraries/History';

import socket from '../libraries/socket';

const config = require("../config");

function parseQueryString(rawUrl) {
  return _.chain(rawUrl)
    .replace('?', '') // a=b454&c=dhjjh&f=g6hksdfjlksd
    .split('&') // ["a=b454","c=dhjjh","f=g6hksdfjlksd"]
    .map(_.partial(_.split, _, '=', 2)) // [["a","b454"],["c","dhjjh"],["f","g6hksdfjlksd"]]
    .fromPairs() // {"a":"b454","c":"dhjjh","f":"g6hksdfjlksd"}
    .value()
}

export default class StartSessionContainer extends PageContainer {
  state = {
    allowedDisplayedCardToParticipant: [],
    draft: null,
    template: null,
    draftSession: null, 
    fields: null, 
    draftSessions: null,
    sessionNumber: 1,
    participants: [null],
    notes: [],
    note: '',
    value: '',
    isShowing: true,
    isHidden: {},
    isComplete: false, 
  }

  options = {
    getFromSession: [],
    defaultState: {
      draft: Draft.mock(),
      template: Template.mock(),
      participants: [..._.range(3).map(i => User.mock()), {...User.mock(), leader: true}],
      draftSessions: {
        current: null,
        next: _.head(Template.mock().sessions),
        completed: [],
        remaining: _.slice(Template.mock().sessions, 1)
      }
    },
    flags: [{
      name: 'isLoaded',
      check: () => true,
    }]
  }

  socketListeners = []

  async setup(props) {
    await this.subscribeToSession();
    
    // if (!(this.state.draft && this.state.draftSessions && this.state.template)) {
    //   await session.fetchLocal();
      // await this.setState( state => _.assign(state, this.options.defaultState));
      // session.selectTemplate(this.state.template);

      // session.selectTe\mplate(this.options.defaultState.template);
      // session.selectCard(this.options.defaultState.selectedParents);
      // const draft = session.createDraft();
      // console.log(draft);
      // session.startJam(draft);
    // }
    // this.state.draft.set('_id', props.match.params.id);
  }

  startDraftSession(draftSession, draft) {
    if (!this.state.draft) {
      session.startJam(draft); 
      // session.set('template', draft.template);
      session.startDraftSession(draftSession, draft);
      const sessionParams = parseQueryString(window.location.search);

      console.log('startDraftSession', session.user._id, draft.createdBy._id);

      this.setState({
        draft: session.get('draft'), 
        draftSession: session.get('draftSession'),
        leader: session.user._id === draft.createdBy._id || sessionParams.leader === 'true'
      })
      .then(() => this.setupSocket())
      .then(() => {

        this.subscribeToStore(session.get('draftSession'), ['fields', 'createdAt']);

        this.state.draftSession.store$.subscribe((data) => {
          //console.log('Draft session changed', data, this.state.fields);
        });
      })
    }
  }

  setupSocket() {
    const uuid = socket.on('toggle draft session card', (payload) => {
        const { draftId, cardId, visible } = payload;
        console.log('StartSessionContainer:toggle draft session card',  cardId, visible);
        this.setState({
          isHidden: {...this.state.isHidden, [cardId]: visible}
        });
      });

    this.socketListeners.push(uuid);

    socket.auth();
    socket.syncWithParticipants();
  }

  destroy() {
    this.unsubscribeAll();
    this.socketListeners.forEach(id => socket.off({id}))
  }

  handleShowParticipantToggle = id => (e) => {
    this.setState(state => {
      let isHidden = state.isHidden[id]; 

      if (isHidden === undefined) {
        isHidden = true; 
      }
      
      return _.assign(state, {isHidden: {...state.isHidden, [id]: !isHidden}});
    }).then(() => {
      console.log('StartSessionContainer:handleShowParticipantToggle', this.state.isHidden);
      socket.emit('toggle draft session card', {
        draftId: this.state.draft._id,
        cardId: id,
        visible: this.state.isHidden[id]
       });
    });
  }

  checkIsComplete = () => {
    const filledUpFields = this.state.draftSession.fields; 
    const expectedOutputs = this.state.draftSession.output
      .map(o => o.slug)
      .filter(o => !/_notes/.test(o)); 

    // console.log('oh god', {
    //   isComplete: this.state.isComplete, 
    //   expectedOutputs, 
    //   filledUpFields
    // });

    if (_.every(expectedOutputs, (o) => filledUpFields[o] && filledUpFields[o].length)) {
      this.setState(state => ({
        ...state, 
        isComplete: true
      }));
    } else { 
      // Don't trigger render of the page every time, only trigger when it's changed 
      this.setState(state => ({
        ...state, 
        isComplete: false
      }));
    }
  }


  handleOnChange = (output) => (event) => { // if (this.state.draft.createdBy !== session.get('user')._id) {
    //   return; 
    // }

    let value = event; 

    if (event.target) {
      value = event.target.value
    }

    session.get('draftSession').setField({
      [_.snakeCase(output.slug)]: value
    });

    this.checkIsComplete();

    session.save();


    if (this.state.draft.createdBy !== session.get('user')._id) {
      socket.syncChangesWithParticipants({
        [_.snakeCase(output.slug)]: value
      }); 
    }
  }

  constructor(props) {
    super(props);
    this.getPropsFromSession(this.options.getFromSession);
    this.setupFlags(this.options.flags);
  }
}



// WEBPACK FOOTER //
// ./src/containers/StartSessionContainer.js